import { getIn } from "formik"
import React from "react"
import { FilePicker as JBFilePicker } from "shared/ui/berry-jass"
import { getErrorText } from "./helpers"

export const fieldToFilePicker = ({
  disabled,
  field,
  onChange = null,
  form: {
    errors,
    touched,
    isSubmitting,
    setSubmitting,
    setFieldValue,
    setFieldError,
    setFieldTouched
  },
  ...props
}) => {
  const fieldError = getIn(errors, field.name)
  const showError = getIn(touched, field.name) && !!fieldError

  const {
    onChange: _onChange,
    onBlur: _onBlur,
    multiple: _multiple,
    ...fieldRest
  } = field

  return {
    error: showError,
    helperText: showError ? getErrorText(fieldError) : null,
    disabled: disabled || isSubmitting,
    onUploadStart: () => {
      setFieldTouched(field.name)
      setSubmitting(true)
    },
    onUploadSettled: () => {
      setSubmitting(false)
    },
    onUploadError: (error) => {
      setFieldError(field.name, error.response?.data?.file)
    },
    onChange: function handleChange(_event, value) {
      if (onChange) {
        onChange(_event, value)
      }

      setFieldValue(field.name, value)
      setFieldTouched(field.name)
    },
    ...fieldRest,
    ...props
  }
}

export const FilePicker = (props) => {
  return <JBFilePicker {...fieldToFilePicker(props)} />
}
